export default __webpack_public_path__ + "static/media/warning--other-danger--g3.1ee8a971.png";